import NextImage from 'next/image'
import { STATIC_IMAGE_BASE } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { useStaticData } from '@mc/static-data-react'
import { Locations } from '@mc/track-event'
import CTA from 'components/CTA'
import Logo from 'components/Navigation/MCLogo/assets/logo.svg'
import { PricingText } from 'components/PricingText'
import { PrunedCourse } from 'libs/server/api'
import { CM_TIMELINE_VIEW_I18N_NAMESPACE } from '../../../../i18n'
import { DefaultNameplate } from './DefaultNameplate'
import { getChaptersAndDuration } from './utils'
import classes from './Hero.module.scss'

// same as CTASection of web/apps/next/src/components/HighContrastHero/components/HeroContent.tsx
const finalTrackProps = {
  category: 'video-playlist-module',
  content_type: 'product',
  location: Locations.HERO,
}

export const Content = () => {
  const { t } = useTranslation(CM_TIMELINE_VIEW_I18N_NAMESPACE)
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()
  const { chaptersCount, courseDuration } = getChaptersAndDuration(course)

  return (
    <div className='container'>
      <div className='row justify-content-between align-items-end'>
        <div className='col-12 col-md-6 col-lg-5 d-flex flex-column align-items-start mc-text--left'>
          <div className='d-none d-md-block'>
            <Logo className='mc-icon mc-icon--4 mc-text-color--primary' />
          </div>
          <div className='d-block d-md-none'>
            <Logo className='mc-icon mc-icon--3 mc-text-color--primary' />
          </div>
          <DefaultNameplate />
          <p className='mc-opacity--muted mc-text-small'>
            {course?.marketingCmColumn}
          </p>
          <div className='mc-mt-4 mc-text--bold d-flex align-items-center flex-gap-2'>
            <p className='mc-text-small'>
              {t('variant_2.hero.lessons', {
                lessonsCount: chaptersCount,
              })}
              <span style={{ opacity: 0.5 }}>{` · ${courseDuration}`}</span>
            </p>
          </div>
        </div>
        <div className='col-12 col-md-6 col-lg-5 mc-text--center d-flex justify-content-center justify-content-md-end'>
          <div
            className={`mc-px-3 mc-py-2 flex-shrink-0 ${classes.pricingContainer}`}
          >
            <NextImage
              src={`${STATIC_IMAGE_BASE}/CM_instructors_hero_2x.png`}
              alt=''
              width={183}
              height={38}
            />
            <p className={`body mc-p-3 ${classes.pricingContainer__text}`}>
              {t('variant_2.hero.allClasses', {
                instructors: getNumberOfInstructors(),
              })}
            </p>
            <CTA fullWidth trackProps={finalTrackProps} className='mc-my-3' />
            <PricingText translationKey='shortPriceStyled'>
              <span className='mc-opacity--muted' />
              <span className='mc-text--bold' />
            </PricingText>
          </div>
        </div>
      </div>
    </div>
  )
}
